module.exports = __webpack_public_path__ + "media/images/emblems/Binn-coat_of_arms-d77726530336b3ebb712e0f3be130060.svg";